/**
 * Flag de pago APM hosted / TPV externo en curso para el flujo de cambio de
 * butaca.
 *
 * Los pagos que redirigen el navegador a una pasarela externa (Bizum APM
 * hosted, TPV Redsys) desmontan la SPA. El flujo de cambio de butaca libera
 * su sesión al desmontarse (`onUnmounted` → `cancelar()` → `liberarSesion()`)
 * y en `beforeunload` (`liberarSesionKeepalive()`); sin este flag, la reserva
 * se borra antes de que el webhook de la pasarela procese el pago completado
 * y el cambio de asiento nunca se aplica.
 *
 * El flag guarda el session_id de la reserva en curso. La liberación de
 * sesión lo respeta (no borra) mientras coincida, y se limpia al volver de
 * la pasarela (onMounted de la vista), al reservar de nuevo, o al cerrar la
 * pestaña (sessionStorage es por pestaña).
 *
 * Se usa `globalThis.sessionStorage` (no `window`) para que el polyfill de
 * los tests funcione: en el entorno mocha-webpack `window !== globalThis` y
 * tienen instancias de sessionStorage distintas. En el navegador real
 * `globalThis === window`, así que no hay diferencia de comportamiento.
 */

export const CAMBIO_BUTACA_PAGO_EN_CURSO_KEY = 'cambio_butaca_pago_en_curso';

/** Lee el session_id con pago en curso (null si no hay). */
export function getPagoEnCursoSessionId() {
    try {
        return globalThis.sessionStorage?.getItem(CAMBIO_BUTACA_PAGO_EN_CURSO_KEY) || null;
    } catch (_) {
        return null;
    }
}

/** Marca el session_id como pago en curso. */
export function marcarPagoEnCurso(sessionId) {
    try {
        globalThis.sessionStorage?.setItem(CAMBIO_BUTACA_PAGO_EN_CURSO_KEY, sessionId);
    } catch (_) {
        // sessionStorage no disponible (privacy mode): sin flag, la sesión
        // se liberará al desmontar como antes; el backend restaura la
        // sesión cancelada cuando el webhook llega con pago completado.
    }
}

/** Limpia el flag de pago en curso. */
export function limpiarPagoEnCurso() {
    try {
        globalThis.sessionStorage?.removeItem(CAMBIO_BUTACA_PAGO_EN_CURSO_KEY);
    } catch (_) {
        // no-op
    }
}
